import { createAsyncThunk } from '@reduxjs/toolkit';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { SupportedLocales } from '@/models/localization.model';
import { BASE_API_URL } from '@/constants/common';
import { LOCALES_SLICE_NAME } from './models';

export const getLocales = createAsyncThunk<SupportedLocales[], void, { serializedErrorType: IApiError }>(
  `${LOCALES_SLICE_NAME}/getLocales`,
  async () => {
    const response = await fetch(`${BASE_API_URL}/api/languages`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();

    return data?.languages;
  },
  { serializeError: formatApiError },
);
